export const COOKIES_AGREEMENT_ACCEPTED_KEY = 'cookie_agreement_accepted';
